import { useState } from 'react';
import { TaxReportsPanel } from '../../tax-reports';
import DailyStatsLogs from '../shared/DailyStatsLogs';
import WbStatistics from './WbStatistics';
import WbMissedSales from './WbMissedSales';

function WbSection({ wbAccountId, wbAccountName, wbAccounts, setWbAccountId }) {
    const [wbTab, setWbTab] = useState('statistics');

    if (!wbAccounts || wbAccounts.length === 0) {
        return (
            <div className="empty">
                Нет подключенных кабинетов Wildberries. Добавьте кабинет в настройках.
            </div>
        );
    }

    return (
        <>
            <div className="panel__head">
                <div>
                    <h3>Инструменты Wildberries</h3>
                    {wbAccounts.length > 1 && (
                        <div className="form-group">
                            <label>Выберите кабинет:</label>
                            <select
                                value={wbAccountId || ''}
                                onChange={(e) => setWbAccountId(e.target.value)}
                            >
                                {wbAccounts.map((acc) => (
                                    <option key={acc.id} value={acc.id}>
                                        {acc.account_name || acc.name || `Кабинет #${acc.id}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {wbAccounts.length === 1 && (
                        <p className="muted">Кабинет: {wbAccountName}</p>
                    )}
                </div>
            </div>

            {wbAccountId && (
                <>
                    <div className="account-tabs account-tabs--secondary">
                        <button
                            type="button"
                            className={wbTab === 'statistics' ? 'active' : ''}
                            onClick={() => setWbTab('statistics')}
                            title="Запрос по API к маркетплейсу сейчас"
                        >
                            Статистика
                        </button>
                        <button
                            type="button"
                            className={wbTab === 'missed-sales' ? 'active' : ''}
                            onClick={() => setWbTab('missed-sales')}
                            title="Анализ упущенной выручки и рекомендации"
                        >
                            Упущенные продажи
                        </button>
                        <button
                            type="button"
                            className={wbTab === 'stats-logs' ? 'active' : ''}
                            onClick={() => setWbTab('stats-logs')}
                            title="Сохранённая статистика за период работы в сервисе"
                        >
                            Статистика (Логи)
                        </button>
                        <button
                            type="button"
                            className={wbTab === 'tax-reports' ? 'active' : ''}
                            onClick={() => setWbTab('tax-reports')}
                        >
                            Налоговые отчеты
                        </button>
                    </div>

                    {wbTab === 'statistics' && (
                        <WbStatistics
                            accountId={wbAccountId}
                            accountName={wbAccountName}
                        />
                    )}

                    {wbTab === 'missed-sales' && (
                        <WbMissedSales
                            accountId={wbAccountId}
                            accountName={wbAccountName}
                        />
                    )}

                    {wbTab === 'stats-logs' && (
                        <DailyStatsLogs
                            accountId={wbAccountId}
                            accountName={wbAccountName}
                            marketplace="wildberries"
                        />
                    )}

                    {wbTab === 'tax-reports' && (
                        <TaxReportsPanel
                            accountId={wbAccountId}
                            accountName={wbAccountName}
                            marketplace="wildberries"
                        />
                    )}
                </>
            )}
        </>
    );
}

export default WbSection;
